@if(powerAppId && powerAppLink){
<ion-row class="flex justify-around">
  <iframe
    [title]="powerAppTitle"
    class="h-[90dvh] w-[90dvw] xs:max-h-[650px] xs:max-w-[95dvw] max-h-[780px] sm:max-h-[800px] max-w-sm lg:max-h-[900px] 2xl:max-w-md 2xl:max-h-[900px] 4xl:max-w-lg"
    frameborder="0"
    allowtransparency="true"
    [src]="powerAppLink"
    allow="geolocation; microphone; camera"
    sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation-by-user-activation"></iframe>
</ion-row>
} @else{
<ion-row class="flex justify-center">
  <ion-text class="text-center text-lg font-bold">
    No content available.
  </ion-text>
</ion-row>
}
